import { render, staticRenderFns } from "./JiuYe.vue?vue&type=template&id=4b5eba45&scoped=true"
import script from "./JiuYe.vue?vue&type=script&lang=js"
export * from "./JiuYe.vue?vue&type=script&lang=js"
import style0 from "./JiuYe.vue?vue&type=style&index=0&id=4b5eba45&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5eba45",
  null
  
)

export default component.exports